import React from "react";
import CardSkeleton from "./CardSkeleton";

type Props = {
  number: number;
};

const SkeletonList = ({ number }: Props) => {
  return (
    <>
      {Array(number)
        .fill(0)
        .map((item, index) => {
          return <CardSkeleton key={index} />;
        })}
    </>
  );
};

export default SkeletonList;
